<template>
  <div>
    ... espere un momento !
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  props: ["envioID"],
  firestore: {
    Clientes: db.collection("Cliente"),
  },
  data() {
    return {
      Clientes: null,
      Envio: {},
    };
  },
  mounted() {
    this.$bind("Envio", db.collection("Envios").doc(this.envioID));
  },
  watch: {
    async Envio(x) {

      await db.collection("Cliente").doc(x.Recibe).get().then((item) => { 
        x.Destinatario = item.data(); 
        x.Destinatario.id=item.id;
      });
    await db.collection("Cliente").doc(x.Envia).get().then((item) => { 
        x.Remitente = item.data(); 
        x.Remitente.id=item.id;
    });

    x.IdEnvio=this.envioID;
    x.FechaEnvio= x.Fecha.toDate();

      localStorage.Envio = JSON.stringify({ ...x });
      this.$router.push("/courier/envios");
    },
  },
};
</script>
